import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { IMandatesStore } from '../../../stores/MandatesStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import BoxNotice from '../../common/BoxNotice';

interface ILimitedMandateNoticeProps {
  translateStore?: ITranslateStore;
  mandatesStore?: IMandatesStore;
}

@inject('translateStore', 'mandatesStore')
@observer
export default class LimitedMandateNotice extends React.Component<ILimitedMandateNoticeProps> {
  public componentDidMount(): void {
    this.props.mandatesStore.tryLoadMandate();
  }

  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const mandate = this.props.mandatesStore.mandate;

    if (mandate.isFinishedWithError) {
      throw new Error('Loading mandate failed');
    }

    if (mandate.isFinished && mandate.payload.billingMandateLevel === 'PARTIAL') {
      return <BoxNotice>{translate('shared.notices.limited-mandate-notice')}</BoxNotice>;
    }

    return null;
  }
}
